import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  required,
} from 'react-admin';
import { TicketCategory, TicketPriority } from '../../generated/data-contracts';
import { Box, Typography } from '@mui/material';

export const TicketsCreate: React.FC = () => (
  <Create title='Crear Nuevo Ticket'>
    <SimpleForm>
      <Box display='flex' flexDirection='column' gap={2}>
        <Typography variant='h6' gutterBottom>
          Información del Ticket
        </Typography>

        <TextInput
          source='title'
          label='Título'
          validate={[required()]}
          fullWidth
          helperText='Título descriptivo del problema o solicitud'
        />

        <TextInput
          source='description'
          label='Descripción'
          multiline
          rows={6}
          validate={[required()]}
          fullWidth
          helperText='Describe detalladamente el problema, error o solicitud'
        />

        <SelectInput
          source='category'
          label='Categoría'
          choices={[
            { id: TicketCategory.Bug, name: 'Error/Bug' },
            { id: TicketCategory.Feature, name: 'Nueva Funcionalidad' },
            { id: TicketCategory.Support, name: 'Soporte' },
            { id: TicketCategory.Contact, name: 'Contacto' },
            { id: TicketCategory.General, name: 'General' },
          ]}
          validate={[required()]}
          defaultValue={TicketCategory.General}
        />

        <SelectInput
          source='priority'
          label='Prioridad'
          choices={[
            { id: TicketPriority.Low, name: 'Baja' },
            { id: TicketPriority.Medium, name: 'Media' },
            { id: TicketPriority.High, name: 'Alta' },
            { id: TicketPriority.Critical, name: 'Crítica' },
          ]}
          defaultValue={TicketPriority.Medium}
          helperText='Selecciona la prioridad según la urgencia del problema'
        />
      </Box>
    </SimpleForm>
  </Create>
);
